import { useCallback, useEffect, useState } from "react";
import { Select, MbscPopupDisplay } from "@mobiscroll/react";
import { IonIcon, IonItem, IonText } from "@ionic/react";
import { airplaneOutline } from "ionicons/icons";
import ContactProfileImage from "./ContactProfileImage";

import { useCoverTeacherSearch } from "../../hooks/useCoverTeacherSearch";

import "./CoverTeacherSelect.css";

export type SelectedCoverTeacher = {
  _id: string;
  Name: string;
  Email?: string;
};

const CoverTeacherInputProps = {
  inputStyle: "outline",
  labelStyle: "stacked",
};

interface CoverTeacherSelectProps {
  color?: string;
  value?: string | number;
  onChange?: (event: any, inst?: any) => void;
  isOpen?: boolean;
  searchDate?: string;
  placeholder?: string;
  display?: MbscPopupDisplay | undefined;
}

const renderTeacherItem = (item: any) => {
  const absent = !isNaN(item?.data?.teacher?.Absences)
    ? item?.data?.teacher?.Absences > 0
    : false;
  return (
    <IonItem
      className={
        "teacher-select-item" + (absent ? " teacher-select-absent" : "")
      }
      key={item?.data?.teacher?._id}
    >
      <div slot="start">
        <ContactProfileImage
          cssClass="list-profile-image"
          profile={{ contactId: item?.data?.teacher?._id }}
          onSelect={() => {
            console.log("disabled.");
          }}
        />
      </div>
      {absent && <IonIcon icon={airplaneOutline} slot="end" color="danger" />}

      <IonText>{item.display}</IonText>
    </IonItem>
  );
};

const CoverTeacherSelect: React.FC<CoverTeacherSelectProps> = ({
  value: _value,
  color: _color,
  onChange,
  isOpen,
  searchDate,
  placeholder,
  display
}) => {
  const [remoteData, setRemoteData] = useState<any[]>([]);

  const {
    coverTeacherSearchResult,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setCoverTeacherSearchResult,
    coverTeacherResultLoaded,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    refreshCoverTeacherResult,
    coverTeacherSearchFilter,
    setCoverTeacherSearchFilter,
  } = useCoverTeacherSearch();

  const remoteFiltering = useCallback(
    (filterText: string) => {
      if (filterText === "") {
        setRemoteData([]);
        return;
      }
      const filter = { search: filterText, date: searchDate ?? "" };
      const newSearch = { ...coverTeacherSearchFilter, ...filter };
      setCoverTeacherSearchFilter(newSearch);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [useCoverTeacherSearch]
  );

  const onFilter = useCallback(
    (ev: any) => {
      remoteFiltering(ev.filterText);
      return false;
    },
    [remoteFiltering]
  );

  useEffect(() => {
    remoteFiltering("");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [useCoverTeacherSearch]);

  useEffect(() => {
    if (coverTeacherResultLoaded) {
      const teachers = coverTeacherSearchResult.map((teacher: any) => {
        return {
          text: teacher?.Name,
          value: teacher?._id,
          teacher: teacher,
        };
      });
      setRemoteData(teachers);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coverTeacherSearchResult]);

  return (
    <Select
      data={remoteData}
      display={display !== undefined ? display : "anchored"}
      filter={true}
      inputProps={CoverTeacherInputProps}
      filterPlaceholderText={placeholder ? placeholder : "Add cover teacher..."}
      onFilter={onFilter}
      onChange={onChange}
      isOpen={isOpen}
      focusOnOpen={true}
      renderItem={renderTeacherItem}
      buttons={["clear"]}
    />
  );
};

export default CoverTeacherSelect;
